// FILE: quizmaster/app/src/main.js
// DESC: This is the main entry point of our Vue application.

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css"; // We will create this file for Tailwind

createApp(App).use(router).mount("#app");
